import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from "../../../models/app-filter.model";
import { Zona } from "../../../models/zona";
import { AbHorarios } from "app/abstract/full-pages/horarios/horarios.abstract";

@Injectable({ providedIn: 'root' })
export class HorariosService extends AbHorarios {
    prefixo = "horarios";

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete(`${this.prefixo}/`, id);
    }

    public getAllNomeHorarios(filter: AppFilter) {
        return this.get(`${this.prefixo}/filter/${filter.encode()}`);
    }

    public getAllNomeHorariosAtivos() {
        return this.get(`${this.prefixo}/all/ativos`);
    }

    public saveUpdateNomeHorarios(obj: Zona) {
        return this.save(`${this.prefixo}/`, obj);
    }

    public getNomeHorarios(id: number) {
        return this.get(`${this.prefixo}/`, id);
    }
}